import React, { useContext, useCallback, useEffect, useState } from "react";
import {
  Col,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import { GoClock } from "react-icons/go";
import { GoCalendar } from "react-icons/go";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileTimePicker, MobileDatePicker } from "@mui/x-date-pickers";
import { TextField, InputAdornment } from '@mui/material';
import { Language, LoginUserData } from "../../../App";
import { RiImageAddFill } from "react-icons/ri";
import ImageCropModal from "../../common/ImageCropModal";
import { TiCancel } from "react-icons/ti";
import { toast } from "react-toastify";
import { AddEventApi, AddEventQuestionApi } from "../../../constants/API";
import axios from "axios";
import moment from "moment";
import AddQuestionModal from "./AddQuestionModal";
import LocationModal from "./LocationModal";
import { getToken } from "../../../shared/token";
import { getTime, parse } from "date-fns";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useCheckSubscriptionPermission } from "../../../hooks/useCheckSubscriptionPermission";
import { useMixpanelTracking } from "../../../hooks/useMixpanelTracking";
import { MixpanelEvents } from "../../../constants/MixpanelEvents";
const CreateEventModal = ({ isOpen, toggle }) => {
  const { lang } = useContext(Language);
  const { track } = useMixpanelTracking();
  const { splashData } = useContext(LoginUserData);
  const checkPermission = useCheckSubscriptionPermission('upload_event');
  const [addQuestionModal, setAddQuestionModal] = useState(false);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [locationModal, setLocationModal] = useState(false);
  const [eventInput, setEventInput] = useState(null);
  const [formData, setFormData] = useState({
    eventTitle: "",
    organizerName: "",
    eventCategory: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    location: "",
    address: "",
    website: "",
    registrationLink: "",
    availability: "",
    audienceLimit: null,
    password: "",
    eventPrice: null,
    description: "",
    lat_lng: ""
  });
  const [city, setCity] = useState(null)
  const [country, setCountry] = useState(null)
  const [mapCenter, setMapCenter] = useState(null);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [timeInput, setTimeInput] = useState({
    hr_start: "",
    min_start: "",
    median_start: "",
    hr_end: "",
    min_end: "",
    median_end: "",
  });
  const [startTimeValue, setStartTimeValue] = useState(null);   // For time picker
  const [endTimeValue, setEndTimeValue] = useState(null);   // For time picker
  const [startDateValue, setStartDateValue] = useState(null);   // For date picker
  const [endDateValue, setEndDateValue] = useState(null);   // For date picker
  const [formattedTime, setFormattedTime] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [data, setData] = useState({
    title: "",
    subcategory_id: "",
    caption: "",
    schedule_date: null,
    schedule_time: null,
    duration: null,
    type: "clinical-session"
  });
  const [time, setTime] = useState(null);
  const [questionsData, setQuestionsData] = useState([]);
  const [questionsCount, setQuestionsCount] = useState(0);
  const [icon, setIcon] = useState(<FaRegEyeSlash />);
  const [type, setType] = useState("password");
  // sessionStorage
  const SplashData = JSON.parse(localStorage.getItem("SplashData"));
  const user_id = SplashData?.user?.id;

  const HH = [];
  for (let i = 1; i <= 12; i++) {
    const num = i > 9 ? `${i}` : `0${i}`;
    HH.push(num);
  }
  const MM = [];
  for (let i = 0; i <= 60; i++) {
    const num = i > 9 ? `${i}` : `0${i}`;
    MM.push(num);
  }
  // Generic handleChange function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const isToday = (someDate) => {
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };
  // Function to validate the form
  const validateForm = () => {
    const numericRegex = /^[0-9]+$/;
    const urlRegex = /^(http|https):\/\/[^ "]+$/;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const currentDay = currentDate.getDate().toString().padStart(2, "0");
    const currentDateString = `${currentYear}-${currentMonth}-${currentDay}`;
    if (!croppedImage) {
      toast.error(lang?.please_select_event_cover_image || "Please select event cover image");
      return false;
    }
    if (formData?.eventTitle.trim() === "") {
      toast.error(lang?.please_enter_event_title || "Please enter event title");
      return false;
    }
    if (formData?.organizerName.trim() === "") {
      toast.error(lang?.please_enter_event_titles || "Please enter organizer name");
      return false;
    }
    if (formData?.eventCategory.trim() === "") {
      toast.error(lang?.please_enter_event_titles || "Please enter event category");
      return false;
    }

    // Validate Start Time
    if (timeInput.hr_start || timeInput.min_start || timeInput.median_start) {
      if (!timeInput.hr_start || !timeInput.min_start || !timeInput.median_start) {
        toast.error(lang?.please_enter_event_start_time);
        return false;
      }
    }

    // Validate End Time
    if (timeInput.hr_end || timeInput.min_end || timeInput.median_end) {
      if (!timeInput.hr_end || !timeInput.min_end || !timeInput.median_end) {
        toast.error(lang?.please_enter_event_time);
        return false;
      }
    }

    // Validate Start Time
    if (timeInput.hr_start || timeInput.min_start || timeInput.median_start) {
      if (!timeInput.hr_start || !timeInput.min_start || !timeInput.median_start) {
        toast.error("Please enter a valid event start time");
        return false;
      }
    }

    // Validate End Time
    if (timeInput.hr_end || timeInput.min_end || timeInput.median_end) {
      if (!timeInput.hr_end || !timeInput.min_end || !timeInput.median_end) {
        toast.error("Please enter a valid event end time");
        return false;
      }
    }

    // Combine Start Date and Time
    const startHour = parseInt(timeInput.hr_start, 10) % 12 + (timeInput.median_start.toLowerCase() === "pm" ? 12 : 0);
    const startMinute = parseInt(timeInput.min_start, 10);
    const startDateTime = new Date(
      `${formData.startDate}T${String(startHour).padStart(2, "0")}:${String(startMinute).padStart(2, "0")}:00`
    );

    // Combine End Date and Time
    const endHour = parseInt(timeInput.hr_end, 10) % 12 + (timeInput.median_end.toLowerCase() === "pm" ? 12 : 0);
    const endMinute = parseInt(timeInput.min_end, 10);
    const endDateTime = new Date(
      `${formData.endDate}T${String(endHour).padStart(2, "0")}:${String(endMinute).padStart(2, "0")}:00`
    );

    // Validation for same day
    if (formData.startDate === formData.endDate) {
      if (startDateTime < currentDate) {
        toast.error(lang.select_time_after_the_current_time);
        return false;
      }

      if (endDateTime < currentDate) {
        toast.error(lang.please_select_end_time_after_start_time);
        return false;
      }

      if (endDateTime <= startDateTime) {
        toast.error(lang.please_select_end_time_after_start_time);
        return false;
      }
    } else {
      // Validation for different dates
      if (startDateTime < currentDate) {
        toast.error(lang.select_time_after_the_current_time);
        return false;
      }

      if (endDateTime <= startDateTime) {
        toast.error("End date must be after the start date and time");
        return false;
      }
    }

    // Validate start and end date
    if (formData?.startDate > formData?.endDate) {
      toast.error(lang?.start_date_should_greater_end_date);
      return false;
    }

    if (formData?.startDate < currentDateString) {
      toast.error(lang?.start_date_cannot_less_today_date);
      return false;
    }

    if (formData?.endDate < currentDateString) {
      toast.error(lang?.end_date_cannot_less_today_date);
      return false;
    }
    // const startHour = parseInt(timeInput.hr_start, 10) % 12 + (timeInput.median_start.toLowerCase() === "pm" ? 12 : 0);
    // const startMinute = parseInt(timeInput.min_start, 10);
    // const startDateTime = new Date(
    //   `${formData.startDate}T${String(startHour).padStart(2, "0")}:${String(startMinute).padStart(2, "0")}:00`
    // );

    // // Combine End Date and Time
    // const endHour = parseInt(timeInput.hr_end, 10) % 12 + (timeInput.median_end.toLowerCase() === "pm" ? 12 : 0);
    // const endMinute = parseInt(timeInput.min_end, 10);
    // const endDateTime = new Date(
    //   `${formData.endDate}T${String(endHour).padStart(2, "0")}:${String(endMinute).padStart(2, "0")}:00`
    // );

    // Calculate Time Difference in Seconds
    const timeDifferenceInSeconds = (endDateTime.getTime() - startDateTime.getTime()) / 1000;

    // Validate Time Difference
    const tenMinutesInSeconds = 10 * 60;
    if (timeDifferenceInSeconds < tenMinutesInSeconds) {
      toast.error(lang?.there_should_least_minute_betwen_s_time_e_time);
      return false;
    }
    // Validate time difference between start and end
    // const startUnixTime = new Date(formData?.startDate).getTime() / 1000;
    // const endUnixTime = new Date(formData?.endDate).getTime() / 1000;
    // const timeDifferenceInSeconds = endUnixTime - startUnixTime;
    // const tenMinutesInSeconds = 10 * 60;

    // if (timeDifferenceInSeconds < tenMinutesInSeconds) {
    //   toast.error(lang?.there_should_least_minute_betwen_s_time_e_time);
    //   return false;
    // }
    // const currentDate = new Date();
    const selectedStartDate = new Date(formData?.startDate);

    if (isToday(selectedStartDate)) {
      const hasStartTimeInput = timeInput.hr_start && timeInput.min_start && timeInput.median_start;
      if (!hasStartTimeInput) {
        toast.error(lang?.please_enter_event_start_time || "Please enter start time if event is today");
        return false;
      }
    }
    // Validate website URL
    if (formData?.website && !urlRegex.test(formData?.website)) {
      toast.error(lang?.website_url_note_valid);
      return false;
    }

    // Validate registration link URL
    if (formData?.registrationLink && !urlRegex.test(formData?.registrationLink)) {
      toast.error(lang?.registration_link_url_not_valid);
      return false;
    }

    // Validate password length
    if (formData.availability.trim() === "") {
      toast.error(lang?.please_enter_event_description || "Please enter Availability");
      return false;
    }
    if (formData?.password && formData?.password.length < 6) {
      toast.error(lang?.password_should_min_characters);
      return false;
    }

    if (formData.description.trim() === "") {
      toast.error(lang?.please_enter_event_description || "Please enter event description");
      return false;
    }
    // If all validations pass, return true
    return true;
  };
  const handleTimeChange = (newValue) => {

    setStartTimeValue(newValue);
    setFormattedTime(moment(newValue).format("hh:mm A"));  // Set time in 24-hour format
    setData((prevData) => ({ ...prevData, schedule_time: moment(newValue).format("hh:mm A") }))

    setTime(moment(newValue).format("hh:mm A"))
    const startDateTime = new Date(newValue)
    let hours = startDateTime.getHours();   // 12 (in 24-hour format)
    let minutes = startDateTime.getMinutes(); // 00

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format (JavaScript Date object gives hours in 24-hour format)
    hours = hours % 12;  // Convert to 12-hour format
    hours = hours ? hours : 12;  // If hour is 0 (midnight), set it to 12

    // Format minutes to always be two digits
    minutes = minutes < 10 ? "0" + minutes : minutes;
    setTimeInput({ ...timeInput, min_start: minutes, hr_start: hours, median_start: period });
    // Now you have separate hour, minute, and AM/PM
  };
  const handleTimeOpen = (type) => {

    if (type === "start_time") {
      toast.error(lang.select_start_date_first);
      return false; // Prevents picker from opening
    } else if (type === "end_date") {
      toast.error(lang.select_start_date_first)
    } else if (type === "end_time") {
      toast.error(lang.select_end_date_first)
    }
    return true; // Allows picker to open
  };
  const handleTimePickerOpen = () => {
    const currentTimePlusFive = moment().add(5, 'minutes');

    setStartTimeValue(currentTimePlusFive);
    setFormattedTime(moment(currentTimePlusFive).format("hh:mm A"));  // Set time in 24-hour format
    setData((prevData) => ({ ...prevData, schedule_time: moment(currentTimePlusFive).format("hh:mm A") }))
    setTime(moment(currentTimePlusFive).format("hh:mm A"))
    const startDateTime = new Date(currentTimePlusFive)
    let hours = startDateTime.getHours();   // 12 (in 24-hour format)
    let minutes = startDateTime.getMinutes(); // 00

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format (JavaScript Date object gives hours in 24-hour format)
    hours = hours % 12;  // Convert to 12-hour format
    hours = hours ? hours : 12;  // If hour is 0 (midnight), set it to 12

    // Format minutes to always be two digits
    minutes = minutes < 10 ? "0" + minutes : minutes;
    setTimeInput({ ...timeInput, min_start: minutes, hr_start: hours, median_start: period });
  }
  const handleEndTimeChange = (newValue) => {
    setEndTimeValue(newValue);
    setFormattedTime(moment(newValue).format("hh:mm A"));  // Set time in 24-hour format
    setData((prevData) => ({ ...prevData, schedule_time: moment(newValue).format("hh:mm A") }))
    setTime(moment(newValue).format("hh:mm A"))
    const startDateTime = new Date(newValue)
    let hours = startDateTime.getHours();   // 12 (in 24-hour format)
    let minutes = startDateTime.getMinutes(); // 00

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format (JavaScript Date object gives hours in 24-hour format)
    hours = hours % 12;  // Convert to 12-hour format
    hours = hours ? hours : 12;  // If hour is 0 (midnight), set it to 12

    // Format minutes to always be two digits
    minutes = minutes < 10 ? "0" + minutes : minutes;
    setTimeInput({ ...timeInput, min_end: minutes, hr_end: hours, median_end: period });
  };
  // Handle date change
  const handleDateChange = (newValue) => {
    setStartDateValue(newValue);
    const formatted = moment(newValue).format("YYYY-MM-DD");
    setFormattedDate(formatted);
    setFormData((prev) => {
      const updated = { ...prev, startDate: formatted };
      if (prev.endDate && moment(prev.endDate).isBefore(moment(formatted), "day")) {
        updated.endDate = "";
        setEndDateValue(null);
      }
      return updated;
    });
    setData((prevData) => ({ ...prevData, schedule_date: formatted }));

    if (newValue && moment(newValue).isSame(moment(), 'day')) {
      const nowPlus5 = moment().add(5, 'minutes');
      if (!startTimeValue || moment(startTimeValue).isBefore(nowPlus5)) {
        handleTimeChange(nowPlus5);
      }
    }
  };
  const handleEndDateChange = (newValue) => {
    setEndDateValue(newValue);
    const formatted = moment(newValue).format("YYYY-MM-DD");
    setFormattedDate(formatted);
    setFormData((prev) => ({ ...prev, endDate: formatted }));
    setData((prevData) => ({ ...prevData, schedule_date: formatted }));

    if (startDateValue && newValue && moment(startDateValue).isSame(moment(newValue), 'day')) {
      if (startTimeValue) {
        if (!endTimeValue || moment(endTimeValue).isSameOrBefore(moment(startTimeValue))) {
          handleEndTimeChange(moment(startTimeValue).clone().add(1, 'hour'));
        }
      }
    }
  };
  const handleSubmit = () => {
    // Check permission for event upload
    if (!checkPermission()) {
      return; // Toast "Buy a Subscription!" already shown
    }

    // Perform validation
    if (!validateForm()) {
      return; // Exit if validation fails
    }
    const isToday = (someDate) => {
      const today = new Date();
      return (
        someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
      );
    };

    const formatAMPM = (date) => {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;

      return `${hours}:${minutes} ${ampm}`;
    };

    const startDate = new Date(formData.startDate);

    // Prepare Start and End Time
    //   const StartTime = timeInput.hr_start && timeInput.min_start && timeInput.median_start
    // ? `${timeInput.hr_start}:${timeInput.min_start} ${timeInput.median_start}`
    // : "12:01 AM";
    // const StartTime =
    // isToday(startDate)
    //   ? formatAMPM(new Date(Date.now() + 60 * 60 * 1000)) // Add 1 hour
    //   : (timeInput.hr_start && timeInput.min_start && timeInput.median_start)
    //     ? `${timeInput.hr_start}:${timeInput.min_start} ${timeInput.median_start}`
    //     : "12:01 AM";
    const autoStartTime = new Date(Date.now() + 15 * 60 * 1000);

    const StartTime =
      isToday(startDate)
        ? (timeInput.hr_start && timeInput.min_start && timeInput.median_start)
          ? `${timeInput.hr_start}:${timeInput.min_start} ${timeInput.median_start}`
          : formatAMPM(autoStartTime)
        : (timeInput.hr_start && timeInput.min_start && timeInput.median_start)
          ? `${timeInput.hr_start}:${timeInput.min_start} ${timeInput.median_start}`
          : "12:01 AM";
    const EndTime = `${timeInput.hr_end}:${timeInput.min_end} ${timeInput.median_end}`;
    const StartTimeDate = `${formData.startDate} ${StartTime ? StartTime : "12:01 AM"}`;
    const dateObject = parse(StartTimeDate, "yyyy-MM-dd hh:mm a", new Date());
    const StartunixTimestamp = getTime(dateObject) / 1000;
    const EndTimeDate = timeInput.hr_end && timeInput.min_end && timeInput.median_end
      ? `${timeInput.hr_end}:${timeInput.min_end} ${timeInput.median_end}`
      : "11:59 PM";
    const _EndTimeDate = `${formData.endDate} ${EndTimeDate}`;
    const enddateObject = parse(_EndTimeDate, "yyyy-MM-dd hh:mm a", new Date());
    const EndunixTimestamp = getTime(enddateObject) / 1000;
    const data = {
      cover_base64: croppedImage,
      start_timestamp: StartunixTimestamp,
      end_timestamp: EndunixTimestamp,
      user_id,
      title: formData?.eventTitle,
      organizer: formData?.organizerName,
      description: formData?.description,
      date: formData?.startDate,
      time: StartTime,
      availability: formData?.availability,
      location: formData?.lat_lng ? `${city}, ${country}` : "",
      short_location: formData?.address || "",
      lat_lng: formData?.lat_lng
        ? `${formData?.lat_lng.lat},${formData?.lat_lng.lng}`
        : "",
      website: formData?.website || "",
      link: formData?.registrationLink || "",
      end_date: formData?.endDate,
      end_time: EndTimeDate,
      password: formData?.password || "",
      limit: formData?.audienceLimit || null,
      price: formData?.eventPrice || "",
      tags: "@nnn",
      category_id: "3",
      subcategory_id: formData?.eventCategory,
    };
    // Set loading state
    setIsLoading(true);

    // Perform API call
    axios
      .post(AddEventApi, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getToken()}`
        },
      })
      .then((res) => {
        // Track create event
        track(MixpanelEvents.createEvent, {
          event_title: formData?.eventTitle,
          event_category: formData?.eventCategory,
          event_price: formData?.eventPrice || 0,
          has_questions: questionsData && questionsData.length > 0,
          timestamp: new Date().toISOString(),
        });

        if (questionsData && questionsData.length > 0 && questionsData[0].question) {
          const questionData = {
            event_id: res.data.event_id,
            questions: questionsData.map((q) => ({
              question: q.question,
              type:
                q.type ||
                (q.answers?.length > 0 ? "Multiple Choice" : "Short Answer"),
              answers: q.answers || [],
            })),
          };
          axios
            .post(AddEventQuestionApi, questionData, {

              headers: {
                Authorization: `Bearer ${getToken()}`, // Set the Authorization header
              },

            })
            .then((res) => {
              setIsLoading(false);
              if (res?.data?.status) {
                window.location.reload();
                toast.success(lang.event_added_successfully)
              } else {
                toast.error("Error", res.data.action);
              }
            })
            .catch((error) => {
              toast.error("Error", error);
              setIsLoading(false);
            });
        } else {
          toast.success("Event Added Successfully!")
          setIsLoading(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        toast.error(error);
        setIsLoading(false);
      })

  };



  const toggleImagePreview = () => setIsImagePreviewOpen(!isImagePreviewOpen);

  const handleCropComplete = (croppedImageURL) => {
    setCroppedImage(croppedImageURL);
    setIsCropModalOpen(false);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setEventInput(file)
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setIsCropModalOpen(true);
      };
    }
  };
  const handleRemoveImage = () => {
    setCroppedImage(null);
    setImageSrc(null);
    const fileInput = document.getElementById('fileInput');
    if (fileInput) {
      fileInput.value = ''; // Clear the input value to allow re-uploading the same image
    }
  };
  const handleLocation = () => {
    if (formData?.lat_lng || markerPosition) {
      setLocationModal(true);
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          setMapCenter({ lat: latitude, lng: longitude });
          setMarkerPosition({ lat: latitude, lng: longitude });
          setLocationModal(true); // Only show modal if location access is granted
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            toast.error(lang?.geolocation_permission_denied || "Location permission denied.");
          } else {
            toast.error(lang?.geolocation_error || "Unable to retrieve location.");
          }
          // Do NOT open modal if geolocation fails
        }
      );
    } else {
      toast.error(lang?.geolocation_not_suported || "Geolocation is not supported by this browser.");
    }
  };

  const onSave = useCallback((markerPosition) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      lat_lng: markerPosition,
    }));
  }, [])
  const getQuestions = (questions, count) => {
    setQuestionsData(questions);
    setQuestionsCount(count)
  };
  const handleToggle = () => {
    setType(type === "password" ? "text" : "password");
    setIcon(type === "password" ? <FaRegEye /> : <FaRegEyeSlash />);
  };
  const isStartTodayModal = startDateValue && moment(startDateValue).isSame(moment(), 'day');
  const futureTime = isStartTodayModal ? moment().add(5, 'minutes') : undefined;

  const isSameDayModal = startDateValue && endDateValue && moment(startDateValue).isSame(moment(endDateValue), 'day');
  const isEndTodayModal = endDateValue && moment(endDateValue).isSame(moment(), 'day');
  const futureEndTime = isSameDayModal
    ? (startTimeValue ? moment(startTimeValue).clone().add(5, 'minutes') : (isEndTodayModal ? moment().add(10, 'minutes') : undefined))
    : (isEndTodayModal ? moment().add(5, 'minutes') : undefined);
  return (
    <>
      <Offcanvas isOpen={isOpen} toggle={toggle}>
        <OffcanvasHeader>{lang.create_event}</OffcanvasHeader>
        <OffcanvasBody>
          <p className="fs-14 roboto-regular text-gray">
            {lang.fill_event_fields}
          </p>
          <Row>
            <Col>
              <Row>
                <Col>
                  {croppedImage ? (
                    <div
                      className="position-relative"
                      style={{
                        cursor: "pointer",
                        border: "1px dashed #A2A2A2",
                        minHeight: "128px",
                        borderRadius: "6px",
                      }}
                      onClick={toggleImagePreview}
                    >
                      <img
                        src={croppedImage}
                        name="cover"
                        alt="Cropped Preview"
                        className="w-100 br-16"
                        style={{ objectFit: "cover", height: "8rem" }}
                      />
                      <button
                        className="bg-white position-absolute end-0 me-3 mt-3 br-6 bg-white border-0 px-2 py-0 fs-16 roboto-bold"
                        style={{
                          top: "-10px",
                          right: "-10px",
                          background: "transparent",
                          border: "none",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveImage();
                        }}
                      >
                        x
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        cursor: "pointer",
                        border: "1px dashed #A2A2A2",
                        minHeight: "128px",
                        borderRadius: "6px",
                      }}
                      className="d-flex flex-column align-items-center justify-content-center"
                      onClick={() => {
                        document.getElementById("fileInput").click();
                      }}
                    >
                      <RiImageAddFill size={20} color="#848798" />
                      <h4 className="fs-14 roboto-medium pt-3" style={{ color: "#848798" }}>
                        {lang?.add_event_cover}
                      </h4>

                    </div>
                  )}
                  <input
                    type="file"
                    id="fileInput"
                    name="cover"
                    className="d-none"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                  {errors.cover && <p className="text-danger">{errors.cover}</p>}
                </Col>

              </Row>
              <Form className="mt-3">
                <Row className="mb-3">
                  <Col>
                    <input
                      type="text"
                      className="py-2 form-control"
                      name="eventTitle"

                      placeholder={lang?.event_title}
                      value={formData.eventTitle}
                      onChange={handleChange}
                    />
                    {errors.eventTitle && <p className="text-danger">{errors.eventTitle}</p>}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      type="text"
                      className="py-2 form-control"
                      value={formData.organizerName}
                      onChange={handleChange}
                      name="organizerName"
                      placeholder={lang?.organizer_name}
                    />
                    {errors.organizerName && <p className="text-danger">{errors.organizerName}</p>}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <select className="form-select py-2"
                      name="eventCategory"
                      // value={formData.eventCategory}
                      onChange={handleChange}
                    >

                      <option disabled selected hidden>
                        {lang?.event_category}
                      </option>

                      {splashData &&
                        splashData.home &&
                        splashData.home.subcategories &&
                        splashData.home.subcategories.map((value, index) => (
                          <option value={value.id} key={index}>
                            {value.name}
                          </option>
                        ))}
                    </select>
                    {errors.eventCategory && <p className="text-danger">{errors.eventCategory}</p>}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Col>
                      <MobileDatePicker
                        label={startDateValue ? "" : lang.start_date || "Start Date"}
                        value={startDateValue}
                        // onOpen={()=>handlePickerOpen("start")}
                        minDate={moment().startOf('day')}
                        // minDate={moment().add(1, 'days').startOf('day')}
                        onChange={handleDateChange}
                        // onAccept={handleDateChange} 

                        slotProps={{
                          textField: {
                            className: "custom-input",
                            InputLabelProps: { shrink: false },  // Prevent label from shrinking upwards
                            InputProps: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <GoCalendar style={{ cursor: 'pointer' }} />
                                </InputAdornment>
                              ),
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth style={{ width: '100%', height: '40px' }} />
                        )}
                      />
                      {errors.schedule_date && <p className="text-danger">{errors.schedule_date}</p>}
                    </Col>
                    <Col>
                      {startDateValue ? (
                        <MobileTimePicker
                          label={startTimeValue ? "" : lang.start_time || "Start Time"}
                          value={startTimeValue}
                          minTime={futureTime}
                          onOpen={handleTimePickerOpen} // Picker opens normally
                          onChange={handleTimeChange}
                          slotProps={{
                            textField: {
                              className: "custom-input",
                              InputLabelProps: { shrink: false },
                              InputProps: {
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <GoClock style={{ cursor: 'pointer' }} />
                                  </InputAdornment>
                                ),
                              },
                            },
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      ) : (
                        <TextField
                          label={lang.start_time || "Start Time"}
                          className="custom-input"
                          InputLabelProps={{ shrink: false }}
                          onClick={() => handleTimeOpen("start_time")} // Trigger toast when clicked

                          InputProps={{
                            readOnly: true, // Prevent manual typing
                            endAdornment: (
                              <InputAdornment position="end">
                                <GoClock
                                  style={{ cursor: 'pointer' }}
                                // onClick={handleTimeOpen} // Trigger toast when clicked
                                />
                              </InputAdornment>
                            ),
                          }}

                        // disabled // Disabled placeholder
                        />
                      )}


                      {errors.schedule_time && <p className="text-danger">{errors.schedule_time}</p>}
                    </Col>
                  </LocalizationProvider>

                </Row>
                <Row className="mb-3">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Col>
                      {startDateValue ?
                        <MobileDatePicker
                          label={endDateValue ? "" : lang.end_date || "End Date"}
                          value={endDateValue}
                          // onOpen={()=>handlePickerOpen("end")}
                          minDate={moment().startOf('day')} // Disable previous dates (before today)
                          // onChange={handleEndDateChange}
                          onChange={handleEndDateChange}
                          slotProps={{
                            textField: {
                              className: "custom-input",
                              InputLabelProps: { shrink: false },  // Prevent label from shrinking upwards
                              InputProps: {
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <GoCalendar style={{ cursor: 'pointer' }} />
                                  </InputAdornment>
                                ),
                              },
                            },
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth style={{ width: '100%', height: '40px' }} />
                          )}
                        /> : (
                          <TextField
                            label={endDateValue ? "" : lang.end_date || "End Date"}
                            className="custom-input"
                            InputLabelProps={{ shrink: false }}
                            onClick={() => handleTimeOpen("end_date")} // Trigger toast when clicked

                            InputProps={{
                              readOnly: true, // Prevent manual typing
                              endAdornment: (
                                <InputAdornment position="end">
                                  <GoCalendar
                                    style={{ cursor: 'pointer' }}
                                  // onClick={handleTimeOpen} // Trigger toast when clicked
                                  />
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              '& .MuiInputBase-input::placeholder': {
                                color: 'rgba(0, 0, 0, 0.7)', // darker placeholder
                                opacity: 1, // required for non-IE browsers
                              },
                            }}

                          />
                        )}
                      {errors.schedule_date && <p className="text-danger">{errors.schedule_date}</p>}
                    </Col>
                    <Col>
                      {endDateValue ? <MobileTimePicker
                        label={endTimeValue ? "" : lang.end_time || "End Time"}
                        value={endTimeValue}
                        minTime={futureEndTime}
                        onChange={handleEndTimeChange}
                        slotProps={{
                          textField: {
                            className: "custom-input",
                            InputLabelProps: { shrink: false },  // Prevent label from shrinking upwards
                            InputProps: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <GoClock style={{ cursor: 'pointer' }} />
                                </InputAdornment>
                              ),
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <TextField {...params} />
                        )}
                      /> : (
                        <TextField
                          label={lang.end_time || "End Time"}
                          className="custom-input"
                          InputLabelProps={{ shrink: false }}
                          onClick={() => handleTimeOpen("end_time")} // Trigger toast when clicked

                          InputProps={{
                            readOnly: true, // Prevent manual typing
                            endAdornment: (
                              <InputAdornment position="end">
                                <GoClock
                                  style={{ cursor: 'pointer' }}
                                // onClick={handleTimeOpen} // Trigger toast when clicked
                                />
                              </InputAdornment>
                            ),
                          }}

                        // disabled // Disabled placeholder
                        />
                      )}


                      {errors.schedule_time && <p className="text-danger">{errors.schedule_time}</p>}
                    </Col>
                  </LocalizationProvider>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <label className="pb-1 fs-15 roboto-medium">
                      {lang?.location}{" "}
                      <span style={{ opacity: "0.3" }}>{lang.opti}</span>
                    </label>
                    <div className="position-relative">
                      <input
                        onClick={handleLocation} // Opens the modal when clicked
                        type="text"
                        className="py-2 form-control"
                        placeholder={lang.city_country}
                        value={
                          formData?.lat_lng && city && country
                            ? `${city}, ${country}`
                            : ""
                        }
                        readOnly
                      />
                      {formData?.lat_lng && city && country && (
                        <div
                          className="position-absolute end-0 top-0 me-2"
                          style={{ marginTop: "13px" }}
                        >
                          <h6
                            className="text-primary cursor"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                lat_lng: "", // Clear lat_lng in formData
                              });
                              setCity(""); // Clear city
                              setCountry(""); // Clear country
                            }}
                          >
                            <TiCancel size={18} />
                            {lang?.remove || "Remove"}
                          </h6>
                        </div>
                      )}
                    </div>
                  </Col>

                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      type="text"
                      name="address"
                      className="py-2 form-control"
                      placeholder="Address (optional)"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      type="url"
                      name="website"
                      className="py-2 form-control"
                      value={formData.website}
                      onChange={handleChange}
                      placeholder={lang?.website + " " + lang.opti}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      type="url"
                      className="py-2 form-control"
                      placeholder={lang?.registration_link + " " + lang.opti}
                      value={formData.registrationLink}
                      name="registrationLink"
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <select name="availability" className="form-select py-2"
                      value={formData.availability}
                      onChange={handleChange}
                    >
                      <option selected disabled className="placeholder-option" hidden value="" style={{ color: "#bcbdbe" }}>
                        {lang?.choose_availablity}
                      </option>
                      <option value="Online">{lang?.online}</option>
                      <option value="Offline">{lang?.offline}</option>
                      <option value="Online & Offline">
                        {lang?.online_offline}
                      </option>
                    </select>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      type="number"
                      autoComplete="off"
                      name="audienceLimit"
                      className="py-2 form-control"
                      placeholder={lang?.audience_limit + " " + lang.opti}
                      value={formData.audienceLimit}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <div style={{ position: "relative" }}>
                      <input
                        autoComplete="new-password"
                        type={type}
                        name="password"
                        className="py-2 form-control"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder={lang?.set_password + " " + lang.opti}
                        style={{ paddingRight: "40px" }} // Add padding to make space for the icon
                      />
                      <span
                        className="position-absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#7991A4",
                          cursor: "pointer", // Optional: make icon clickable
                        }}
                        onClick={handleToggle} // Uncomment to toggle password visibility
                      >
                        {icon}
                      </span>
                    </div>
                  </Col>

                  {/* <Col>
                      <input
                        autoComplete="new-password"
                        type="password"
                        name="password"
                        className="py-2 form-control"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder={lang?.set_password + " " +lang.opti}
                      />
                         <span
                        className="position-absolute"
                        style={{
                          right: "11px",
                          top: "12px",
                          color: "#7991A4",
                        }}
                        // onClick={handleToggle}
                      >
                        {icon}
                      </span>
                    </Col> */}
                </Row>
                <Row className="mb-3">
                  <Col>
                    <input
                      autoComplete="off"
                      type="number"
                      name="eventPrice"
                      className="py-2 form-control"
                      placeholder={lang?.event_price + " " + lang.opti}
                      value={formData.eventPrice}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <textarea
                      className="form-control resize"
                      name="description"
                      rows="5"
                      placeholder={lang?.description}
                      value={formData.description}
                      onChange={handleChange}
                    ></textarea>
                    {errors.description && <p className="text-danger">{errors.description}</p>}

                  </Col>
                </Row>
                <div style={{ padding: "25px 25px 6px 0px", border: "1px solid #E0E0E0", borderRadius: "6px" }}>
                  {/* <hr style={{ opacity: "0.2" }} /> */}
                  <Row className="mb-3 justify-content-between">
                    <Col>
                      <div className="d-flex">
                        <button
                          type="button"
                          onClick={() => {
                            // toggle();
                            setAddQuestionModal(true);
                          }}
                          className="btn bg-gray text-black roboto-bold px-4"
                        >
                          <b>{lang?.add_question}</b>{" "}
                          <span className="text-secondary">{lang.opti}</span>
                        </button>
                        {questionsCount > 0 && <div className="align-self-center  col-md-1">
                          <div className="bg-blue text-center rounded-circle" style={{ padding: "4px 4px 2px 3px" }}>
                            <h5 className="text-white mb-0" style={{ marginTop: "-3px" }}>{questionsCount}</h5>
                          </div>
                        </div>}
                      </div>

                    </Col>
                  </Row>
                </div>
                {/* <hr style={{ opacity: "0.2" }} /> */}

                <Row>
                  <Col>
                    <button
                      type="button"
                      className="bg-secondary text-white border-0 w-100 my-4 py-3 rounded fw-bold"
                      onClick={toggle}
                    >
                      {lang?.cancel}
                    </button>
                  </Col>
                  <Col>
                    <button
                      type="button"
                      className="btn-blue border-0 w-100 my-4 py-3 rounded fw-bold"
                      onClick={handleSubmit}
                      disabled={
                        isLoading
                        ||
                        !eventInput ||
                        !formData?.eventTitle ||
                        !formData?.organizerName ||
                        !formData?.description ||
                        !formData?.startDate ||
                        !formData?.endDate ||
                        !formData?.eventCategory
                        ||
                        !formData?.availability
                      }
                    >
                      {isLoading ? <Spinner size="sm" /> : lang?.add_event}
                    </button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </OffcanvasBody>
      </Offcanvas>
      <AddQuestionModal
        isOpen={addQuestionModal}
        toggle={() => setAddQuestionModal(!addQuestionModal)}
        getQuestions={getQuestions}
        existingQuestions={questionsData}
      />
      <ImageCropModal
        isOpen={isCropModalOpen}
        toggle={() => setIsCropModalOpen(!isCropModalOpen)}
        imageSrc={imageSrc}
        aspect={1.78}
        onCropComplete={handleCropComplete}
      />
      <Modal isOpen={isImagePreviewOpen} toggle={toggleImagePreview} centered className="image-preview-modal">
        <img src={croppedImage} alt="Full Preview" className="img-fluid" />
      </Modal>
      {locationModal && <LocationModal
        isOpen={locationModal}
        toggle={() => setLocationModal(!locationModal)}
        mapCenter={mapCenter}
        setMapCenter={setMapCenter}
        markerPosition={markerPosition}
        setMarkerPosition={setMarkerPosition}
        setCity={setCity}
        setCountry={setCountry}
        onSave={onSave}
      />}

    </>
  );
};

export default CreateEventModal